const sessionUrl = '/OxygenSessions/sessions'

function getSettings(params, callback) {
 //console.log("getSettings ", params);
  if(params.Client) {
    let CurrentContext = JSON.parse(params.Client.CurrentContext);
    if(CurrentContext && params.Type) {
      window.BotServices.httpRequest({
        method : 'POST',
        type : "application/json",
        url : sessionUrl + '/' + window.LivingScript_0070.context.sessionId + '/getSettings',
        data : { Context : CurrentContext.grantItem, Type : params.Type, GatewayPE :  CurrentContext.GatewayPE, AgentOfPE : CurrentContext.AgentOfPE, Account : CurrentContext.Account}
      }, callback);
    }
  } else if(params.ContextPE) {
    window.BotServices.httpRequest({
      method : 'POST',
      type : "application/json",
      url : sessionUrl + '/' + window.LivingScript_0070.context.sessionId + '/getSettings',
      data : { ContextPE : params.ContextPE, Type : params.Type}
    }, callback);
  } else {
    callback(null, {});
  }
}

function getRoleSettings(params, callback) {
 //console.log("getRoleSettings ", params);
  if(params.Client) {
    let CurrentContext = JSON.parse(params.Client.CurrentContext);
    if(CurrentContext && params.Type) {
      window.BotServices.httpRequest({
        method : 'POST',
        type : "application/json",
        url : sessionUrl + '/' + window.LivingScript_0070.context.sessionId + '/getRoleSettings',
        data : { Context : CurrentContext.grantItem}
      }, callback);
    }
  } else {
    callback(null, {});
  }
}

function setSettings(params, callback) {
 //console.log("setSettings ", params);
  let CurrentContext = JSON.parse(params.Client.CurrentContext);
  params.Client = null;
  params.AttributionID = CurrentContext.AttributionID;
  if(params && params.PE) {
    window.BotServices.httpRequest({
      method : 'POST',
      type : "application/json",
      url : sessionUrl + '/' + window.LivingScript_0070.context.sessionId + '/setSettings',
      data : params
    }, callback);
  } else {
    callback(null, {});
  }
}

function setPhoneState(params, callback) {
 //console.log("setPhoneState ", params);
  params.Client = null;
  if(params && params.Context) {
    window.BotServices.httpRequest({
      method : 'POST',
      type : "application/json",
      url : sessionUrl + '/' + window.LivingScript_0070.context.sessionId + '/setPhoneState',
      data : params
    }, callback);
  } else {
    callback(null, {});
  }
}

function cleanPhoneSetting(params, callback) {
 //console.log("cleanPhoneSetting ", params);
  if(params && params.PhoneNumber) {
    window.BotServices.httpRequest({
      method : 'POST',
      type : "application/json",
      url : sessionUrl + '/' + window.LivingScript_0070.context.sessionId + '/cleanPhoneSetting',
      data : params
    }, callback);
  } else {
    callback(null, {});
  }
}

function requestSettings(params, callback) {
 //console.log("requestSettings got ", params);
  if(params.Client) {
    let CurrentContext = JSON.parse(params.Client.CurrentContext);
    if(CurrentContext && params.Type) {
      window.BotServices.httpRequest({
        method : 'POST',
        type : "application/json",
        url : sessionUrl + '/' + window.LivingScript_0070.context.sessionId + '/reqSettings',
        data : { Context : CurrentContext, Type : params.Type }
      }, callback);
    }
  } else {
    callback(null, {});
  }
}

function getSettingsHistory(params, callback) {
 //console.log("requestSettings got ", params);
  if(params.PK && params.Client) {
      let CurrentContext = JSON.parse(params.Client.CurrentContext);
      if(CurrentContext && params.PK) {
        window.BotServices.httpRequest({
          method : 'POST',
          type : "application/json",
          url : sessionUrl + '/' + window.LivingScript_0070.context.sessionId + '/getSettingsHistory',
          data : { Context : CurrentContext, PK : params.PK }
        }, callback);
      }
  } else {
    callback(null, {});
  }
}

function get(params, callback) {
 //console.log("get got ", params);
  callback(null, {});
}

function set(params, callback) {
 //console.log("set got ", params);
  callback(null, {});
}

export {
  getSettings,
  setSettings,
  setPhoneState,
  getRoleSettings,
  cleanPhoneSetting,
  requestSettings,
  getSettingsHistory,
}
